export function formatPrice(price: number): string {
    const hasCents = price % 1 !== 0;
    const formatted = price.toLocaleString('en-US', {
        minimumFractionDigits: hasCents ? 2 : 0,
        maximumFractionDigits: hasCents ? 2 : 0,
    });
    return `$${formatted} USD`;
}